<template>
    <div>
    <b-card
      v-if="data"
      class="earnings-card"
    >  
        <!-- Card Header -->
        <div class="d-flex justify-content-between align-items-center">
           <h4 class="mb-2"> Skills Rating</h4>
        </div>
      <b-row>
        
        <b-col md="4">
          <!-- chart -->
          <vue-apex-charts
            height="120"
            :options="earningsChart.chartOptions"
            :series="data.series"
          />
          <h5 class="text-center">Hard Skills</h5>
            
        </b-col>
        <b-col md="4">
          <!-- chart -->
          <vue-apex-charts
            height="120"
            :options="earningsChart.chartOptions"
            :series="data.series"
          />
          <h5 class="text-center">Soft Skills</h5>
          
        </b-col>
        <b-col md="4">
          <!-- chart -->
          <vue-apex-charts
            height="120"
            :options="earningsChart.chartOptions"
            :series="data.series"
          />
          <h5 class="text-center">Other Skills</h5>
          
        </b-col>
        
      </b-row>
    </b-card>
    
        <!-- Card Header -->
       
      <b-row class="match-height">
        
        <b-col md="4">
          <!-- chart -->
          <b-card>
            <h4 class="mb-2">Hard Skills</h4>
            <b-row>
                <b-col md="6">
                    <h5 class="text-center text-primary"> Matched</h5>
                    <candidate-skill-details/>
                </b-col>
                <b-col md="6">
                    <h5 class="text-center text-danger"> Unmatched</h5>
                    <candidate-skill-details/>
                </b-col>    
            </b-row>
          </b-card>  
            
        </b-col>
        <b-col md="4">
          <!-- chart -->
          <b-card>
            <h4 class="mb-2">Soft Skills</h4>
            <b-row>
                <b-col md="6">
                    <h5 class="text-center text-primary"> Matched</h5>
                    <candidate-skill-details/>
                </b-col>
                <b-col md="6">
                    <h5 class="text-center text-danger"> Unmatched</h5>
                    <candidate-skill-details/>
                </b-col>    
            </b-row>
          </b-card>  
          
        </b-col>
        <b-col md="4">
          <!-- chart -->
          
          <b-card>
            <h4 class="mb-2">Other Skills</h4>
            <b-row>
                <b-col md="6">
                    <h5 class="text-center text-primary"> Matched</h5>
                    <candidate-skill-details/>
                </b-col>
                <b-col md="6">
                    <h5 class="text-center text-danger"> Unmatched</h5>
                    <candidate-skill-details/>
                </b-col>    
            </b-row>
          </b-card>  
          
        </b-col>
        
      </b-row>
    
    </div>
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BCardTitle, BCardText,
  } from 'bootstrap-vue'
  import VueApexCharts from 'vue-apexcharts'
  import { $themeColors } from '@themeConfig'


  import CandidateSkillDetails from './CandidateSkillDetails.vue'
  
  const $earningsStrokeColor2 = '#28c76f66'
  const $earningsStrokeColor3 = '#28c76f33'
  export default {
    components: {
      BCard,
      BRow,
      BCol,
      BCardTitle,
      BCardText,
      VueApexCharts,
      CandidateSkillDetails
    },
    props: {
      data: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        earningsChart: {
          chartOptions: {
            chart: {
              type: 'donut',
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            legend: { show: false },
            comparedResult: [2, -3, 8],
            labels: ['App', 'Service', 'Product'],
            stroke: { width: 0 },
            colors: [$earningsStrokeColor2, $earningsStrokeColor3, $themeColors.success],
            grid: {
              padding: {
                right: -20,
                bottom: -8,
                left: -20,
              },
            },
            plotOptions: {
              pie: {
                startAngle: -10,
                donut: {
                  labels: {
                    show: true,
                    name: {
                      offsetY: 15,
                    },
                    value: {
                      offsetY: -15,
                      formatter(val) {
                        // eslint-disable-next-line radix
                        return `${parseInt(val)}%`
                      },
                    },
                    total: {
                      show: true,
                      offsetY: 15,
                      label: 'App',
                      formatter() {
                        return '53%'
                      },
                    },
                  },
                },
              },
            },
            responsive: [
              {
                breakpoint: 1325,
                options: {
                  chart: {
                    height: 100,
                  },
                },
              },
              {
                breakpoint: 1200,
                options: {
                  chart: {
                    height: 120,
                  },
                },
              },
              {
                breakpoint: 1045,
                options: {
                  chart: {
                    height: 100,
                  },
                },
              },
              {
                breakpoint: 992,
                options: {
                  chart: {
                    height: 120,
                  },
                },
              },
            ],
          },
        },
      }
    },
  }
  </script>
  